import React, { useEffect } from 'react'
import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'
import bgDevices from '../../../../Imgs/Home/Devices.png'

function Hero() {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  return (
    <div
      className="relative min-h-[600px] md:h-[800px] flex flex-col md:flex-row items-center justify-center md:justify-between w-full overflow-hidden py-10 md:py-0"
      style={{
        zIndex: 0,
        background: 'linear-gradient(to bottom, #FF4869, #FAB663)'
      }}
    >
      <motion.div
        initial={{ opacity: 0, x: -50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8 }}
        className="z-10 flex flex-col items-center md:items-start justify-center text-center md:text-left px-6 md:px-20 max-w-3xl space-y-4 mb-8 md:mb-0"
      >
        <h2 className="text-3xl md:text-5xl font-bold text-white mb-8">
          Hacemos tu experiencia de comida rápida aún más rápida.
        </h2>
        <span className="text-white">
          Nuestra plataforma, reinventada para los negocios, muy pronto estará
          disponible para tu móvil.
        </span>
        <Link to="https://www.pideypasa.com/registro-restaurante">
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="bg-black text-white px-8 py-3 rounded-full font-semibold text-lg mt-4"
          >
            Registrar mi restaurante
          </motion.button>
        </Link>
        {/* <Link to="https://clientes.pideypasa.com/es">
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="bg-[#FF484A] text-white px-8 py-3 rounded-full font-semibold text-lg mt-4"
          >
            Registrarme como cliente
          </motion.button>
        </Link> */}
      </motion.div>

      <motion.img
        initial={{ opacity: 0, x: 50 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.8, delay: 0.2 }}
        src={bgDevices}
        alt="Devices"
        className="h-64 md:h-auto md:max-h-[600px] w-full max-w-sm md:max-w-md object-contain z-10 md:pr-20 border-0"
      />
    </div>
  )
}

export default Hero
